import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { Auth0Provider } from '@auth0/auth0-react';
import { CookiesProvider } from 'react-cookie';

import { init as b2eInit } from 'services/b2e/services';
import { init } from 'services/core/config';

import config from 'config/auth_config.json';
import Routes from 'routes';
import i18next from './i18n';
import './utils/showVersion';

function App() {
  const [loadCore, setLoadCore] = useState(false);
  const history = useHistory();

  const initializeCore = useCallback(async () => {
    await init();
    setLoadCore(true);
  }, []);

  const onRedirectCallback = (appState: any) => {
    history.push({
      pathname: appState && appState.returnTo ? appState.returnTo : window.location.pathname,
      state: appState && appState.partnerParams,
    });
  };

  useEffect(() => {
    const runB2e = () => {
      b2eInit();
    };
    initializeCore();
    runB2e();
  }, []);

  return (
    <div className="main-portal">
      {loadCore && (
        <CookiesProvider>
          <Auth0Provider
            domain={config.domain}
            clientId={config.clientId}
            audience={config.audience}
            redirectUri={window.location.origin}
            onRedirectCallback={onRedirectCallback}
          >
            <I18nextProvider i18n={i18next}>
              <Routes />
            </I18nextProvider>
          </Auth0Provider>
        </CookiesProvider>
      )}
    </div>
  );
}

export default App;
